import { getUTCAfternoon } from '@epicuro-next/utilities';
import { DateTime } from 'luxon';

export const toDeliveryPeriodFrom = (date: Date) =>
  getUTCAfternoon(
    DateTime.fromJSDate(date, { zone: 'utc' }).toISO({
      suppressMilliseconds: true,
    }),
  );
